import React, { Component } from 'react'
import { Spin, Divider, Popconfirm } from "antd"
import LogAPI from '@/API/log'
import TokenAPI from '@/API/token'
import styled from "styled-components"
import { withTranslation } from 'react-i18next';
import authorization from '@/utils/authorization.js'

const TokenContainer = styled.div`
  display:flex;
  justify-content:center;
  align-items:center;
  width:250px;
  height:50px;
  background-color:#eeeeee;
  margin-bottom:10px;
`;

const Name=styled.div`
  font-weight:bold;
`

const Div = styled.div`
  display:flex;
  flex-direction:row-reverse;
  align-items:center;
`;

class popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token:'',
      loading:false
    };
  }
  componentDidMount() {
    this.getToken()
  }
  logout=()=>{
    // LogAPI.logout()
    authorization.logout()
  }
  toPersonalCenter=()=>{
    window.open(this.props.userInfoUrl)
  }
  getToken=()=>{
    this.setState({loading:true})
    TokenAPI.getToken().then((res)=>{
      if(!res.code){
        this.setState({token:res.info})
      }else{
        this.setState({token:this.props.t('Failed to obtain the token')})
      }
      this.setState({loading:false})
    })
  }
  regenerateToken=()=>{
    this.setState({loading:true})
    TokenAPI.regenerateToken().then((res)=>{
      if(!res.code){
        this.setState({token:res.info})
      }else{
        this.setState({token:this.props.t('Failed to generate the token')})
      }
      this.setState({loading:false})
    })
  }
  render() {
    const {token,loading}=this.state
    const { t,operator } = this.props;

    return (
      <div>
        <Name>{operator}</Name>
        <hr></hr>
        <span>{t('Token')}:</span>
        <Spin spinning={loading}>
          <TokenContainer><div>{token}</div></TokenContainer>
        </Spin>
        <Div>
        <a onClick={this.logout}>{t('Log Out')}</a>
        <Divider type="vertical"></Divider>
        <a onClick={this.toPersonalCenter}>{t('Personal Center')}</a>
        {/* <Divider type="vertical" />
        <Popconfirm placement="bottom" title={t('Are you sure you want to generate a token again?')} okType="danger" onConfirm={this.regenerateToken}>
            <a>{t('Regenerate Token')}</a>
          </Popconfirm> */}
        </Div>
      </div>
    )
  }
}

export default withTranslation()(popup);